var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigureLightBlueb8D0700D6Ec4301C6Fae01A78B413F1F(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1028,
    height: 815,
    viewBox: "0 0 1028 815",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1091 1015.49V1952.36C1091 2022.32 1006.46 2057.32 957.086 2007.8L529.319 1578.8L22.9154 1070.94C-7.63847 1040.31 -7.63847 990.69 22.9154 960.057L529.319 452.198L957.086 23.2C1006.46 -26.3179 1091 8.68172 1091 78.6428V1015.51V1015.49Z",
    fill: "#29ABE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigureLightBlueb8D0700D6Ec4301C6Fae01A78B413F1F);
export default __webpack_public_path__ + "static/media/figure-light-blue.b8d0700d6ec4301c6fae01a78b413f1f.b8d0700d6ec4301c6fae01a78b413f1f.svg";
export { ForwardRef as ReactComponent };